module.exports = __webpack_public_path__ + "static/media/slide-1.e100413f.png";